import * as React from "react";
import "./styles.scss";
import { useProcessController } from "../../../../Processes";
import { VeBoxCard } from "../../../../../components/card/VeBoxCard";
import { CensusCoolerAnalysisProgressBar } from "../CensusCoolerAnalysisProgressBar";
import { useCensusProgressInfo } from "../../data/hooks/CecnsusCoolerControllerHooks";
import { CensusCoolerContext } from "../../providers/CensusCollerProvider";
import { SWRResponse } from "swr";
import { CensusProgressInfo } from "../../data/models/CensusProgressInfo";
import { Display } from "../../../../../components/Display";
import { Loader } from "../../../../../components/Utils/loader/Loader";
import { delay } from "@vebox/etui-core";
import { getFormattedDate } from "../../../../../ReadAndWrite/ReadAndWrite/utils";

interface CensusStatusPageProps {
	totalEquipment?: number;
}

const pollingTime = 2 * 1000; //seconds

export const CensusElaboration: React.FC<CensusStatusPageProps> = ({
	totalEquipment,
}) => {
	// const translations = AppTranslations.massiveActions.changeEquipmentStatus
	const processController = useProcessController();
	const { census, lastUpdatingInfo, updateLastUpdatingInfo } =
		React.useContext(CensusCoolerContext);
	const [shouldFetch, setShouldFetch] = React.useState<boolean>(false);
	const [isLoading, setIsLoading] = React.useState<boolean>(false);
	const censusProgressInfo = useCensusProgressInfo(census?.guid, shouldFetch);

	const getSettingsToUpdate = (): CensusProgressInfo => {
		return lastUpdatingInfo ?? censusProgressInfo?.data;
	};

	const goToNext = () => {
		processController.goTo(processController.position + 1);
	};

	const askForUpdate = async (
		updatingProgressInfo: SWRResponse<CensusProgressInfo, Error, any>,
	) => {
		const result = await updatingProgressInfo.mutate();
		if (result?.processed === result?.total && result?.total > 0) {
			updateLastUpdatingInfo(result);
			await delay(pollingTime);
			goToNext();
		} else {
			setIsLoading(!(result?.total ?? totalEquipment > 0));
			await delay(pollingTime);
			askForUpdate(updatingProgressInfo);
		}
	};

	React.useEffect(() => {
		setShouldFetch(true);
		askForUpdate(censusProgressInfo);
		updateLastUpdatingInfo(undefined);
	}, []);

	return (
		<VeBoxCard className={"census-progress-bar-card"}>
			<Display isVisible={!isLoading}>
				<CensusCoolerAnalysisProgressBar
					count={getSettingsToUpdate()?.processed ?? 0}
					errorsLabel={"Error"}
					total={getSettingsToUpdate()?.total ?? totalEquipment ?? 0}
					updatingFrom={getFormattedDate({ dateToFormat: census?.createdAt })}
					user={census?.username}
				/>
			</Display>
			<Display isVisible={isLoading}>
				<div className={"census-progress-loader"}>
					<Loader relativelyCentered={true} />
				</div>
			</Display>
		</VeBoxCard>
	);
};
